module.exports = __webpack_public_path__ + "media/packs/images/flags/SO-4fe039fa06f7608b293c2df3573c3578.svg";